const actionTypes = {
    SET_NTH_CATEGORY: 'SET_NTH_CATEGORY',
    SET_NTH_CATEGORY_FULFILLMENT_OPTIONS: 'SET_NTH_CATEGORY_FULFILLMENT_OPTIONS'
};

module.exports = actionTypes;
